import { lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage2 from './pages/guide/HomePage2.tsx';
import './styles/App.css';
import './styles/globals.css';
import { nativeCallBack } from './api/nativeCallBack';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './api/react-query.config.ts';
import SearchABRouter from './pages/search/components/SearchABRouter.tsx';
import SearchB from './pages/search/SearchB.tsx';
import TokenCheck from './components/TokenCheck.tsx';
import EventRouter from './pages/Event/EventRouter.tsx';
import ThemeProvider from './ThemeProvider.tsx';
import { TunnelProvider } from './hooks/tunnel/TunnelProvider.tsx';
import { initDatadog } from '@/config/datadog.ts';
import { initVersionLog } from '@/config/versionLog.ts';
import SearchLoading from './pages/search/components/SearchLoading.tsx';
import { getOsType, Os } from './utils/agent.ts';

// Lazy load other components
const LinkPage = lazy(() => import('./pages/guide/LinkPage.tsx'));
const PrivacyPage = lazy(() => import('./pages/guide/PrivacyPage.tsx'));
const GuideRecord = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideRecord,
  })),
);
const GuideViewCall = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideViewCall,
  })),
);
const GuideAICall = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideAICall,
  })),
);
const GuideVoicePhishing = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideVoicePhishing,
  })),
);
const GuideSpamAndroid = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideSpamAndroid,
  })),
);

const GuideSpamIOS = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideSpamIOS,
  })),
);

const GuideSummary = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideSummary,
  })),
);
const GuideDataProtect = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideDataProtect,
  })),
);
const GuideAntiphishing = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideAntiphishing,
  })),
);
const GuideInCallAI = lazy(() =>
  import('./pages/guide/GuidePages.tsx').then((module) => ({
    default: module.GuideInCallAI,
  })),
);

const NativeTest = lazy(() => import('./pages/test/nativeTest.tsx'));

initDatadog();

function App() {
  initVersionLog();
  nativeCallBack();

  const isIOS = getOsType() !== Os.ANDROID;

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TunnelProvider>
          <Router>
            <Routes>
              <Route path="/" element={<HomePage2 />} />

              <Route path="/guide/record" element={<GuideRecord />} />
              <Route path="/guide/viewcall" element={<GuideViewCall />} />
              <Route path="/guide/aicall" element={<GuideAICall />} />
              <Route
                path="/guide/voicephishing"
                element={<GuideVoicePhishing />}
              />
              <Route
                path="/guide/spam"
                element={isIOS ? <GuideSpamIOS /> : <GuideSpamAndroid />}
              />
              <Route path="/guide/summary" element={<GuideSummary />} />
              <Route path="/guide/data" element={<GuideDataProtect />} />
              <Route
                path="/guide/antiphishing"
                element={<GuideAntiphishing />}
              />
              <Route path="/guide/incallai" element={<GuideInCallAI />} />
              <Route path="/privacypolicy" element={<PrivacyPage />} />
              {/* 딥링크 실패시 호출되는 route. 허나 딥링크는 반드시 /link/* 로 시작해야 한다 */}
              <Route path="/link/*" element={<LinkPage />} />

              <Route
                path="/search"
                element={
                  <TokenCheck loadingComponent={<SearchLoading />}>
                    <SearchABRouter />
                  </TokenCheck>
                }
              />
              <Route
                path="/pack-search"
                element={
                  <TokenCheck loadingComponent={<SearchLoading />}>
                    <SearchB isPack={true} />
                  </TokenCheck>
                }
              />
              <Route path="/event/:id?" element={<EventRouter />} />
              <Route path="/test/native" element={<NativeTest />} />
              {/* <Route path='/dummy-search' element={<DummySearch />} /> */}
            </Routes>
          </Router>
        </TunnelProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
